const generalHR = {
    "modalConfirm": {
        "button": {
            "cancel": "Odustani",
            "confirm": "Potvrdi"
        }
    },
    "tableDropdown": {
        "action": "Akcija",
        "edit": "Uredi",
        "delete": "Izbriši",
        "viewDetails": "Pogledaj detalje",
        "copyMLId": "Kopiraj ML ID",
        "viewStats": "Pogledaj statistike"
    },
    "tableModal": {
        "cancel": "Odustani",
        "confirm": "Potvrdi",
        "edit": "Uredi"
    },
    "invoiceModal": {
        "button": {
            "cancel": "Odustani",
            "confirm": "Potvrdi"
        }
    },
    "select": {
        "placeholder": "Odaberite..."
    },
    "asyncDropdown": {
        "placeholder": "Pretraži...",
        "loading": "Učitavanje...",
        "noResults": "Nema opcija",
        "blacklisted": "Na crnoj listi"
    },
    "table": {
        "noDataAvailable": "Nema dostupnih podataka"
    },
    "tableHelper": {
        "loading": "Učitavanje...",
        "error": "Došlo je do pogreške",
        "noData": "Nema dostupnih podataka"
    },
    "countriesSelect": {
        "placeholder": "Pretraži zemlju..."
    },
    "consentModal": {
        "header": "Potrebna suglasnost",
        "body": {
            "description": "Molimo pregledajte i prihvatite naše nove uvjete suglasnosti kako biste nastavili koristiti naše usluge.",
            "label": {
                "firstName": "Ime",
                "lastName": "Prezime",
                "email": "Email",
                "termsOfUsageAgreement": "Slažem se s <1>Uvjetima korištenja</1>",
                "privacyPolicyAgreement": "Slažem se s <1>Pravilima privatnosti</1>",
                "cookiePolicyAgreement": "Slažem se s <1>Pravilima o kolačićima</1>"
            }
        },
        "button": {
            "submit": "Pošalji"
        }
    },
    "passwordResetModal": {
        "header": "Promijenite svoju lozinku",
        "body": {
            "form": {
                "label": {
                    "currentPassword": "Trenutna lozinka",
                    "newPassword": "Nova lozinka",
                    "repeatNewPassword": "Ponovite novu lozinku"
                },
                "button": {
                    "submit": "Pošalji"
                },
                "message": {
                    "currentPasswordRequired": "Potrebna je vaša stara lozinka",
                    "newPasswordRequired": "Potrebna je nova lozinka",
                    "newPasswordMinLength": "Vaša lozinka treba imati najmanje 10 znakova",
                    "newPasswordDifferentFromOld": "Nova lozinka mora biti različita od stare lozinke",
                    "newPasswordConfirmation": "Nova lozinka mora se podudarati"
                }
            }
        },
        "footer": {
            "note": "<strong>Napomena: </strong>Prošlo je neko vrijeme od kada ste zadnji put ažurirali lozinku. Radi vaše sigurnosti, molimo resetirajte lozinku."
        },
        "message": {
            "success": "Vaša lozinka je promijenjena!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovo!"
        },
        "modal": {
            "confirm": {
                "header": "Jeste li sigurni da želite promijeniti lozinku?",
                "body": "Molimo potvrdite"
            }
        }
    },
    "qcFeedback": {
        "label": {
            "qcFeedback": "QC Povratne informacije"
        }
    },
    "subUserFilter": {
        "label": {
            "subUser": "Podkorisnik: "
        },
        "placeholder": {
            "subUser": "Odaberite podkorisnika"
        },
        "button": {
            "reset": "Resetiraj"
        }
    },
    "footer": {
        "label": {
            "copyright": "Autorska prava © {{year}}",
            "allRightsReserved": "Sva prava pridržana.",
            "privacyPolicy": "Pravila privatnosti",
            "termsAndConditions": "Uvjeti i odredbe"
        }
    },
    "promoBannerHeader": {
        "exclusiveOfferFor": "Ekskluzivna ponuda za",
        "off": "OFF",
        "promoCode": "Promo kod",
        "expiresIn": "Istječe u",
        "clickHereToAvailThisOffer": "Kliknite ovdje da biste iskoristili ovu ponudu",
        "availableOnAllSubscriptionPlans": "Dostupno na sve pretplate."
    },
    "promoBanner": {
        "exclusiveOfferFor": "Ekskluzivna ponuda za",
        "off": "OFF",
        "limitedTimePromoOffer": "Ovaj promo kod je stvoren ekskluzivno za vas. Ne propustite ovu priliku!",
        "promoCode": "Vaš promo kod",
        "expiresIn": "Istječe u",
        "days": "Dani",
        "hours": "Sati",
        "minutes": "Minuti",
        "seconds": "Sekunde",
        "availableOnAllSubscriptionPlans": "Ova ekskluzivna ponuda je dostupna na sve pretplate."
    }
};

export default generalHR;